import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as IssueReportService from 'services/agents/issue-report';

export const useIssueReportService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchIssueReports = async (options = {}) => {
    const { error, payload } = await IssueReportService.read({ ...options, token });
    if (error) {
      toast.error('Unable to fetch reports at this time.');
      return { reports: [], size: 0 };
    }

    const reports = payload?.data || payload?.reports || [];
    const size = payload?.meta?.size ?? reports.length;
    return { reports, size };
  };

  const createIssueReport = async (data, options = {}) => {
    const { error, payload } = await IssueReportService.create({ ...options, data, token });
    if (error) {
      toast.error(error || 'Unable to add issue to tenant at this time.');
      return { report: null };
    }

    toast.success('Issue added to tenant successfully.');
    const report = payload?.data || payload?.report || payload || null;
    return { report };
  };

  const updateReportStatus = async (id, status, options = {}) => {
    const { error, payload } = await IssueReportService.updateById(id, {
      ...options,
      data: { status },
      token
    });
    if (error) {
      toast.error(error || 'Unable to update report at this time.');
      return { report: null };
    }

    toast.success('Report updated successfully.');
    const report = payload?.data || payload?.report || payload || null;
    return { report };
  };

  return { fetchIssueReports, createIssueReport, updateReportStatus };
};
